import { api } from './api';
import { API_ENDPOINTS } from '../config/api';

interface CheckoutSessionResponse {
  checkout_url: string;
  session_id: string;
}

interface PortalSessionResponse {
  portal_url: string;
}

export const subscriptionService = {
  async startCheckout(planKey: string): Promise<CheckoutSessionResponse> {
    const { data } = await api.post<CheckoutSessionResponse>(
      API_ENDPOINTS.subscriptions.checkout,
      { plan_key: planKey }
    );
    return data;
  },

  async startCreditCheckout(credits: number): Promise<CheckoutSessionResponse> {
    const { data } = await api.post<CheckoutSessionResponse>(
      API_ENDPOINTS.subscriptions.creditsCheckout,
      { credits }
    );
    return data;
  },

  async openCustomerPortal(): Promise<PortalSessionResponse> {
    const { data } = await api.post<PortalSessionResponse>(API_ENDPOINTS.subscriptions.portal);
    return data;
  },
};

export default subscriptionService;
